// Auth context helper for accessing token outside React components
import * as R from 'ramda';

// Global variables to store auth state
let globalIdTokenClaims: any = null;
let globalAuth0Client: any = null;

export const setGlobalAuthState = (idTokenClaims: any, auth0Client: any) => {
  globalIdTokenClaims = idTokenClaims;
  globalAuth0Client = auth0Client;
};

export const getGlobalIdTokenClaims = () => globalIdTokenClaims;

export const getGlobalAuth0Client = () => globalAuth0Client;

// Helper functions for roles using global state
export const hasRole = (role: string) => {
  if (!globalIdTokenClaims) return false;
  return R.pathOr('', ['https://quashed.co.nz/roles', 0], globalIdTokenClaims) === role;
};

export const getUserId = () => {
  if (!globalIdTokenClaims) return '';
  return globalIdTokenClaims.sub || '';
};

// Cleanup function to remove deprecated localStorage token
export const cleanupDeprecatedTokens = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    localStorage.removeItem('USER_CLAIMS_TOKEN');
  }
};